<!-- 面板 -->
<template>
  <div class="zlr-panel">
    <div>
      <div class="zlr-panel-title">{{title}}</div>
      <div>
        <slot></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  props: ['title'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
.zlr-panel {
  padding: 24px 32px;
  background-color: #fff;
  > div {
    width: 1280px;
    margin: 0 auto;
  }
  &-title {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-bottom: 24px;
  }
}
</style>
